
export default {
  name: 'ReviewsViewMapSectionDirectionCallDetailSection',
  props: {
    contactDetails: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        address: 'IconReviewLocation-24x24',
        call: 'IconReviewCall-24x24',
        website: 'IconReviewUrl-24x24',
        decor: 'IconReviewTag-24x24',
        time: 'IconReviewClock-24x24',
      },
      isWorkingTime: false,
      isPhoneNumber: false,
    };
  },
  methods: {
    toggleDetail() {
      this.isWorkingTime = !this.isWorkingTime;
    },
    togglePhoneNumber() {
      this.isPhoneNumber = !this.isPhoneNumber;
    },
  },
};
